import FolxTheme from './FolxTheme';

export default FolxTheme;
